import { Injectable } from "@angular/core";

@Injectable()
export class DomProvider {
  private window: Window;

  constructor() {
    this.window = this.getNativeWindow();
  }

  public matchMediaMatches(mediaQuery: string) {
    return this.window.matchMedia(mediaQuery).matches;
  }

  public isLocalhost() {
    return this.window.location.hostname === "localhost";
  }

  public urlRoot() {
    return `${this.window.location.protocol}//${this.window.location.hostname}`;
  }

  private getNativeWindow(): Window {
    return window;
  }

  public go(url) {
    this.window.open(url, '_system');
  }
}



// WEBPACK FOOTER //
// ./src/providers/dom/dom.ts